import LiteratureExpertIcon from "@mui/icons-material/LocalLibrary";
import { FormattedMessage } from "react-intl";

import * as sx from "./literature-expert-chip.sx";

export function LiteratureExpertChip() {
  return (
    <sx.Chip
      data-testid="catalyst-literature-expert-chip"
      avatar={<LiteratureExpertIcon fontSize="small" />}
      label={<FormattedMessage id="catalyst.literature-expert.abbreviation" />}
      size="small"
    />
  );
}
